<template>
  <section>
    <h5 class="text-gray-800 fw-bold mb-3">Атрибуты документа</h5>
    <div class="mb-3">
      <span class="badge badge-secondary" v-html="item.typeName"></span> &nbsp;
      <span class="badge badge-secondary" v-html="item.item.number ? 'Резидент' : 'Нерезидент'"></span> &nbsp;
    </div>
    <div class="podft-list p-4 rounded border">
      <div class="podft-list__item" v-if="item.item.number">
        <div class="text-gray-600 fs-7">Гост. номер</div>
        <div class="text-gray-800 fw-medium">{{item.item.number}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">VIN</div>
        <div class="text-gray-800 fw-medium">{{item.item.vin}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Марка</div>
        <div class="text-gray-800 fw-medium">{{item.item.mark}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Модель</div>
        <div class="text-gray-800 fw-medium">{{item.item.model}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Цвет</div>
        <div class="text-gray-800 fw-medium">{{item.item.color}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">ID</div>
        <div class="text-gray-800 fw-medium">{{item.item.id}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Номер регистрации</div>
        <div class="text-gray-800 fw-medium">{{item.item.registration.certificate}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Дата регистрации</div>
        <div class="text-gray-800 fw-medium">{{item.item.registration.date}}</div>
      </div>
      <div class="podft-list__item">
        <div class="text-gray-600 fs-7">Регион регистрации</div>
        <div class="text-gray-800 fw-medium">{{item.item.registration.region_id}}</div>
      </div>
    </div>
  </section>
</template>

<script>
  import PodftAsideModalAppeal from "@/components/Podft/PodftAsideModal/PodftAsideModalAppeal.vue";

  export default {
    name: 'PodftAsideModalVehicle',
    components: {PodftAsideModalAppeal},
    props: {
      item: null
    },
    methods: { }
  }
</script>

<style scoped>

</style>